import React from 'react'
import {AutoFocusPlugin} from '@lexical/react/LexicalAutoFocusPlugin';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin';
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {HistoryPlugin} from '@lexical/react/LexicalHistoryPlugin';
import {LexicalErrorBoundary} from '@lexical/react/LexicalErrorBoundary';
import { QuoteNode } from "@lexical/rich-text";
import { HtmlPlugin } from './plugins/html-plugin';
import { ToolbarPlugin } from './plugins/toolbar-plugin';
import { LinkNode } from "@lexical/link";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";

const theme = {
    paragraph: "editor-paragraph",
    quote: "editor-quote",
    text: {
        bold: "editor-text-bold",
        italic: "editor-text-italic",
        underline: "editor-text-underline",
        strikethrough: "editor-text-strikethrough",
        underlineStrikethrough: "editor-text-underlineStrikethrough",
    },
    link: 'editor-link'
}

function onError(error: unknown) {
    console.error(error);
}

interface TelegramTextEditorProps {
    onInputChange: React.Dispatch<React.SetStateAction<string>>
    handleReset?: () => void
}


export const TelegramTextEditor: React.FC<TelegramTextEditorProps> = ({ onInputChange, handleReset }) => {
    const initialConfig = {
        namespace: 'telegram-editor',
        theme,
        onError,
        nodes: [QuoteNode, LinkNode]
    };

    return (
        <div>
            <LexicalComposer initialConfig={initialConfig}>
                <ToolbarPlugin />
                <RichTextPlugin
                    contentEditable={<ContentEditable className="editor-input" />}
                    ErrorBoundary={LexicalErrorBoundary}
                />
                <HistoryPlugin />
                <AutoFocusPlugin />
                <LinkPlugin />
                <HtmlPlugin
                    onHtmlChanged={onInputChange}
                />
            </LexicalComposer>
        </div>
    );
}